import React, { useState, useEffect } from 'react';
import { Table, Input, Button, Checkbox, message, Drawer, Dropdown, Menu, Modal, DatePicker, Select, Upload, Form, Space, Col, Row } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { createQuote, getAdminRfqLists, getProductList, getTaxCategoryList } from '../../../redux/actions/rfqAction';
import { getAllSupplier, getAllConsumer } from '../../../redux/actions/allDataAction';
import { assignRfqToSupplier, resetAssignRfqStatus } from '../../../redux/actions/assignRfqAction';
import { MinusCircleOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons';
import { getSupplierRfqAcceptedList } from '../../../redux/actions/supplierRfqAction';
import {  useNavigate } from 'react-router-dom';
const { Search } = Input;
const { confirm } = Modal;
const { Option } = Select;
const { TextArea } = Input;

const AcceptedRfqs = ({ filter }) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { logindata } = useSelector((state) => state.auth);
  const { adminRfqData, productList, taxCategoryData } = useSelector((state) => state.rfq);
  const { rfqAcceptedData } = useSelector((state) => state.supplierRfq);
  const allSupplier = useSelector((state) => state.dataSet.allSupplier);
  const allConsumer = useSelector((state) => state.dataSet.allConsumer);
  const manufacturingProcess = useSelector((state) => state.auth.logindata.manufacturing_process);
  const rfqAssignStatus = useSelector((state)=> state.assignRfq.assignStatus)
  const quoteCreateStatus = useSelector((state) => state.rfq.quoteCreateStatus);
  const [filteredData, setFilteredData] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 12,
    total: 0,
  });
  const [sortOrder, setSortOrder] = useState(null);
  const [loading, setLoading] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [userSearchValue, setUserSearchValue] = useState('');
  const [drawerTitle, setDrawerTitle] = useState('');
  const [drawarActiveDataSet, setDrawerActiveDataSet] = useState('');
  const [userList, setUserList] = useState([]);
  const [currentRfqCode, setCurrentRfqCode] = useState('');
  const [currentRfqId,setCurrentRfqId] = useState('');
  const [ filters, setFilters] = useState({})
  const [currentRfq, setCurrentRfq] = useState(null);

  console.log('@@taxCategoryData',taxCategoryData)
  
  const [formData, setFormData] = useState({
    total_cost: '',
    valid_till: null,
    duration: '',
    documents: [],
    payment_term: '',
    terms_conditions: '',
    parts: [],
  });

  let rfqList = rfqAcceptedData && rfqAcceptedData?.data ? rfqAcceptedData.data : [];
  useEffect(()=>{
    if(rfqAssignStatus){
      setTimeout(() => {
        setDrawerVisible(false);
        setSelectedUsers([]);
        setUserSearchValue('');
        dispatch(resetAssignRfqStatus())  
      }, 2000);
    }
  },[rfqAssignStatus])

  useEffect(() => {
    if (drawarActiveDataSet === 'consumer' && allConsumer && allConsumer.length) {
      setUserList(allConsumer);
    }

    if (drawarActiveDataSet === 'supplier' && allSupplier && allSupplier.length) {
      setUserList(allSupplier);
    }

  }, [allSupplier, allConsumer, drawarActiveDataSet]);

  useEffect(() => {
    if (logindata && logindata.token) {
      dispatch(getSupplierRfqAcceptedList(logindata.token));
      dispatch(getAllConsumer(logindata.token));
      dispatch(getAllSupplier(logindata.token));
      dispatch(getProductList(logindata?.token));
      dispatch(getTaxCategoryList(logindata?.token));
    }
  }, [dispatch, logindata]);

  useEffect(() => {
    if (rfqList && rfqList.length > 0) {
      fetchData();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rfqList, pagination.current, pagination.pageSize, sortOrder, searchValue, filters]);

  useEffect(() => {
      if (quoteCreateStatus) {
        form.resetFields(); 
        handleReset();
        setDrawerVisible(false);
      }
    }, [quoteCreateStatus]);


  const getManufacturingProcessValue = (id) => {
    const process = manufacturingProcess.find((d) => d.id === id);
    return process?.process_name || '';
  };

  const handleFormChange = (key, value, file) => {
    setFormData(prev => {
      const updatedFormData = {
        ...prev,
        [key]: value,
      };
  
      const quantity = updatedFormData[`qty_${file?.product_id}`] || 0;
      const rate = updatedFormData[`rate_${file?.product_id}`] || 0;
      const amount = quantity * rate;
  
      return {
        ...updatedFormData,
        [`amount_${file?.product_id}`]: amount,
      };
    });
  };

  const handleReset = () => {
    setFormData({
      total_cost: '',
      valid_till: null,
      duration: '',
      documents: [],
      payment_term: '',
      terms_conditions: '',
      parts: [],
        ...currentRfq,
        ...currentRfq?.files?.reduce((acc, item) => ({
          ...acc,
          [`qty_${item.product_id}`]: item.qty ?? "",
        }), {})
    });
  };

  const transformFormData = (formData, productList) => {
    const files = Object.keys(formData)
      .filter(key => key.startsWith('qty_') || key.startsWith('rate_') || key.startsWith('amount_'))
      .reduce((acc, key) => {
        const [, productId] = key.split('_');
        if (!productId || productId === 'undefined') return acc;
  
        let item = acc.find(i => i.product_id === productId);
  
        if (!item) {
          const product = productList.find(p => p.id === productId);
          item = {
            product: product ? product.product_name : `Unknown Product (${productId})`,
            product_id: productId,
            quantity: "",
            rate: "",
            total_cost: ""
          };
          acc.push(item);
        }
  
        if (key.startsWith('qty_')) item.quantity = formData[key];
        if (key.startsWith('rate_')) item.rate = formData[key];
        if (key.startsWith('amount_')) item.total_cost = formData[key];
  
        return acc;
      }, []);
  
    const uniqueFiles = files.filter((file, index, self) => 
      index === self.findIndex(f => f.product_id === file.product_id)
    );
  
    const transformedData = {
      ...formData,
      files: uniqueFiles
    };
  
    Object.keys(formData).forEach(key => {
      if (key.startsWith('qty_') || key.startsWith('cost_') || key.startsWith('rate_') || key.startsWith('amount_')) {
        delete transformedData[key];
      }
    });
  
    return transformedData;
  };

  const handleSubmit = () => {
    const tranformData = transformFormData(formData, productList)
    const dataToSend = {
      addcomument : formData?.document,
      files: tranformData?.files,
      payment_term: tranformData?.payment_term,
      term_and_cond: tranformData?.term_and_cond,
      timeline_unit: tranformData?.timeline_unit,
      timeline_val: tranformData?.timeline_val,
      rfq_id: tranformData?.rfq_id,
      rfq_code: tranformData?.rfqcode,
      valid_till:  tranformData?.valid_till,
      tax_category: tranformData?.tax_category,
    };

    //console.log('@@dataToSend',dataToSend)
    dispatch(createQuote(dataToSend, logindata?.token));
  };

  const fetchData = () => {
    setLoading(true);
    const data = rfqList.map((d, index) => ({
      rfq_id: d.id,
      rfqcode: d.rfq_code,
      key: index,
      name: d.name,
      email: d.email,
      contact: d.mobile,
      manufacturingProcess: getManufacturingProcessValue(d.manufacturing_process_id),
      designFiles: d.is_design_file === "1" ? "Yes" : "No",
      comments: d.comments,
      files: d.files,
      member_id: d.member_id,
      grade: d.grade,
    }));
  
    const lowerCaseSearchValue = searchValue ? searchValue.toString().toLowerCase() : "";
  
    const filteredData = data.filter((item) => {
      const matchesSearch = lowerCaseSearchValue
        ? item.email?.toLowerCase().includes(lowerCaseSearchValue) ||
          item.contact?.includes(lowerCaseSearchValue) ||
          item.rfqcode?.toLowerCase().includes(lowerCaseSearchValue) ||
          item.name?.toLowerCase().includes(lowerCaseSearchValue)
        : true;
  
      const matchesManufacturingProcess = filters.manufacturingProcess
        ? item.manufacturingProcess === filters.manufacturingProcess
        : true;
  
      const matchesDesignFiles = filters.designFiles?.toLowerCase
        ? item.designFiles?.toLowerCase() === filters.designFiles?.toLowerCase()
        : true; 
  
      return matchesSearch && matchesManufacturingProcess && matchesDesignFiles;
    });
  
    const sortedData = sortOrder
      ? [...filteredData].sort((a, b) => {
          const columnKey = sortOrder.columnKey;
          const aValue = a[columnKey] ?? ""; // Ensure undefined values don't cause issues
          const bValue = b[columnKey] ?? "";
  
          return sortOrder.order === "ascend"
            ? aValue.localeCompare(bValue, undefined, { numeric: true })
            : bValue.localeCompare(aValue, undefined, { numeric: true });
        })
      : filteredData;
  
    const start = (pagination.current - 1) * pagination.pageSize;
    const end = start + pagination.pageSize;
    const pageData = sortedData.slice(start, end);

    setFilteredData(pageData);
    setPagination((prev) => ({
      ...prev,
      total: filteredData.length,
    }));
  
    setLoading(false);
  };

  const handleSearch = (value) => {
    setSearchValue(value);
    setPagination({ ...pagination, current: 1 });
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setPagination(pagination);
    setSortOrder(sorter);
  };

  const showDrawer = (title, dataset, rfqCode, rfqId, rfq ) => {
    if(dataset==='supplier'){ 
      setDrawerTitle(title);
      setDrawerVisible(true);
      setDrawerActiveDataSet(dataset);
      setCurrentRfqCode(rfqCode);
      setCurrentRfqId(rfqId);
      setCurrentRfq(rfq);
      setFormData({
        ...formData,
        ...rfq,
        ...rfq?.files?.reduce((acc, item) => ({
          ...acc,
          [`qty_${item.product_id}`]: item.qty ?? "",
        }), {})
      });
    }
  };

  const closeDrawer = () => {
    confirm({
      title: 'Are you sure you want to leave?',
      content: 'Changes you made may not be saved.',
      onOk() {
        setDrawerVisible(false);
        setSelectedUsers([]);
        setUserSearchValue('');
        setFormData({
          total_cost: '',
          valid_till: null,
          duration: '',
          documents: [],
          payment_term: '',
          terms_conditions: '',
          parts: [],
        })
      },
    });
  };

  const handleUserSearch = (value) => {
    setUserSearchValue(value);
  };

  const handleUserSelect = (userId) => {
    setSelectedUsers((prevSelectedUsers) =>
      prevSelectedUsers.includes(userId)
        ? prevSelectedUsers.filter((id) => id !== userId)
        : [...prevSelectedUsers, userId]
    );
  };

  const handleAssignAndSave = () => {
    console.log('Assigned users:', selectedUsers);
    const request = {
      rfq_id : currentRfqId,
      rfq_code: currentRfqCode,
      supplier_id: selectedUsers
    }
    if(request && request?.rfq_id && request?.rfq_code && request?.supplier_id && request.supplier_id.length){
      dispatch(assignRfqToSupplier(request, logindata.token))
    }
  };

  const filteredUserList = userSearchValue
    ? userList.filter((user) =>
      user.name.toLowerCase().includes(userSearchValue.toLowerCase()) ||
      user.email.toLowerCase().includes(userSearchValue.toLowerCase())
    )
    : userList;

  const menu = (record) => (
    <Menu>
      <Menu.Item key="supplier" onClick={() => showDrawer('Assign to Supplier', 'supplier', record.rfqcode, record.rfq_id, record)}>
        Assign to Supplier
      </Menu.Item>
      <Menu.Item key="consumer" onClick={() => showDrawer('Assign to Consumer', 'consumer', record.rfqcode, record.rfq_id, record)}>
        Assign to Consumer
      </Menu.Item>
    </Menu>
  );

  const columns = [
    {
      title: 'RFQ Code',
      dataIndex: 'rfqcode',
      key: 'rfqcode',
    },
    {
      title: 'Consumer UID',
      dataIndex: 'member_id',
      key: 'member_id',
    },
    {
      title: 'Grade',
      dataIndex: 'grade',
      key: 'grade',
    },
    {
      title: 'Manufacturing Process',
      dataIndex: 'manufacturingProcess',
      key: 'manufacturingProcess',
    },
    {
      title: 'Design Files',
      dataIndex: 'designFiles',
      key: 'designFiles',
    },
    {
      title: 'Comments',
      dataIndex: 'comments',
      key: 'comments',
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <>
            {!filter && <Button type="primary" onClick={() => showDrawer('Generate Quote', 'supplier', record.rfqcode, record.rfq_id, record)} > Generate Quote</Button>}
        </>
      ),
    },
  ];

  const props = (fieldKey) => ({
    name: 'file',
    customRequest: ({ file, onSuccess }) => {
      handleFileUpload(file, fieldKey);
      onSuccess("ok");
    }
  });

  const handleFileUpload = async (file, fieldKey) => {
    const formData = new FormData();
    formData.append('upload[0]', file);
  
    try {
      const response = await fetch('https://factory.demosite.name/api/Api/multipleDocUpload', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${logindata?.token}`,
        },
        body: formData
      });
  
      const result = await response.json();
      if (response.ok) {
        message.success(`${file.name} file uploaded successfully`);
        setFormData(prevState => {
          return { ...prevState, document: result[0]};
        });
      } else {
        message.error(`${file.name} file upload failed.`);
      }
    } catch (error) {
      message.error(`${file.name} file upload failed.`);
    }
  };


   const onFinish = (values) => {
        console.log("values", values, formData);
      };
      
  return (
    <div>
      <h1 style={{ marginBottom: '20px' }}>Rfq List</h1>
      <Space style={{ marginBottom: 16, gap: 16 , flexWrap: 'wrap'}}>
        <Search
          placeholder="Search by RFQ Code/ Email / Name / Contact"
          onChange={(e) => setSearchValue(e.target?.value)}
          style={{ width: 270 }}
          value={searchValue}
        />
        <Select
          placeholder="--Manufacturing Process--"
          style={{ minWidth: 200 }}
          onSelect={(value) => setFilters({ ...filters, manufacturingProcess: value })}
          value={filters?.manufacturingProcess}
        >
          {manufacturingProcess.map((process) => (
            <Option key={process.id} value={process.process_name}>
              {process.process_name}
            </Option>
          ))}
        </Select>
        <Select
          placeholder="--Design Files--"
          style={{ minWidth: 100 }}
          onSelect={(value) => setFilters({ ...filters, designFiles: value })}
          value={filters?.designFiles}
        >
          <Option value="yes">Yes</Option>
          <Option value="no">No</Option>
        </Select>
        <Button
          type="primary"
          onClick={() => {
            setSearchValue('');
            setFilters({});
          }}
          style={{ display: 'block', margin: '0 auto' }}
        >
          Reset
        </Button>
      </Space>
      <div style={{ overflowX: 'auto' }}>
      <Table
        columns={columns}
        dataSource={filteredData}
        pagination={pagination}
        loading={loading}
        onChange={handleTableChange}
        rowClassName={(record, index) => (index % 2 === 0 ? 'table-row-light' : 'table-row-dark')}
      />
      </div>
      <Drawer
        title={drawerTitle}
        width={500}
        onClose={closeDrawer}
        visible={drawerVisible}
        bodyStyle={{ paddingBottom: 80 }}
      >
        <h2 style={{ margin: '0px 10px 10px 0px' }}>{`RFQ Code  :  ${currentRfqCode}`}</h2>
        <div style={{ textAlign: 'right', marginBottom: '10px' }}>
          <Button type="link" onClick={handleReset}>
            Reset Fields
          </Button>
        </div>
      <Form layout="vertical" onFinish={onFinish} form={form} >
        {formData?.designFiles ==='Yes' && (
        <Form.List name="files">
            {() => (
              <>
                {formData?.files?.map((file, index) => (
                 <Space style={{ marginBottom: 2, gap: 8 }}>
                    <Form.Item 
                    label="Product"
                    name={`product_${file?.product_id}`}
                    //rules={[{ required: true, message: 'Missing Product' }]}
                    >
                      <Select placeholder="--Please choose an option--" defaultValue={file?.product_id} disabled>
                      {productList?.map((product) => (
                        <Option key={product.id} value={product.id} >{product.product_name}</Option>
                      ))}
                      </Select>
                    </Form.Item>
                    <Form.Item
                         label="Quantity"
                        name={`qty_${file?.product_id}`}
                        //rules={[{ required: true, message: 'Missing Quantity' }]}
                      >
                      <Input placeholder="Quantity" defaultValue={file?.qty} onChange={(e) => handleFormChange(`quantity_${file?.product_id}`, e.target.value, file)}/>
                    </Form.Item>
                    {/* <Form.Item
                        label="Cost"
                        name={`cost_${file?.product_id}`}
                        rules={[{ required: true, message: 'Missing Cost' }]}
                      >
                      <Input placeholder="Target Cost" onChange={(e) => handleFormChange(`cost_${file?.product_id}`, e.target.value)}/>
                    </Form.Item> */}
                    <Form.Item
                       label="Rate"
                        name={`rate_${file?.product_id}`}
                        rules={[{ required: true, message: 'Missing Rate' }]}
                      >
                     <Input placeholder="Rate" onChange={(e) => {
                        handleFormChange(`rate_${file?.product_id}`, e.target.value, file);
                      }}/>
                    </Form.Item>
                    <Form.Item
                      label="Amount"
                      name={`amount_${file?.product_id}`}
                      //rules={[{ required: true, message: 'Missing Quantity' }]}
                      style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                  >
                    <span   style={{ display: 'flex', }}>{formData?.[`amount_${file?.product_id}`] ?? 0} AED</span>
                  </Form.Item>
                  </Space>
                  ))} 
                  </>
                )}
        </Form.List>)}
      <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
        <Form.Item label="Timeline" required>
          <Input
            value={formData.timeline_val}
            type="number"
            onChange={(e) => handleFormChange('timeline_val', e.target.value)}
            style={{ width: '200px' }}
          />
        </Form.Item>
          <Form.Item
            label="Unit"
            required
          >
            <Select
              value={formData.timeline_unit}
              onChange={(value) => handleFormChange('timeline_unit', value)}
              options={[
                { value: 'Days', label: 'Days' },
                { value: 'Weeks', label: 'Weeks' },
                { value: 'Months', label: 'Months' },
              ]}
              style={{ width: '200px' }}
            />
         </Form.Item>
        </div>
          <Form.Item label="Quote valid till" required>
            <DatePicker
              style={{ width: '100%' }}
              value={formData.valid_till}
              onChange={(date) => handleFormChange('valid_till', date)}
            />
          </Form.Item>
          <Form.Item 
                    label="Tax Category"
                    name={`tax_category`}
                    >
                      <Select placeholder="--Please choose an option--" onChange={(value) => handleFormChange('tax_category', value)}>
                      {taxCategoryData?.data?.map((tax) => (
                        <Option key={tax.id} value={tax.id} >{tax.tax_name}</Option>
                      ))}
                      </Select>
          </Form.Item>
          <Form.Item
            label="Payment terms"
            name="payment_term"
            rules={[{ required: true, message: 'Type payment terms here', }]}
           >
            <TextArea rows={4} placeholder="Type payment terms  here"  maxLength={1024} showCount 
            onChange={(e) => handleFormChange('payment_term', e.target.value)}/>
          </Form.Item>

          <Form.Item
            label="Terms & Conditions"
            name="term_and_cond"
            rules={[{ required: true, message: 'Type terms & conditions here', }]}
           >
            <TextArea rows={4} placeholder="Type terms & conditions here"  maxLength={1024} showCount 
            onChange={(e) => handleFormChange('term_and_cond', e.target.value)}/>
          </Form.Item>
    
          <Form.Item
          name="addcomument"
          label="Documents"
          //rules={[{ required: true, message: "Please upload a document" }]}
          valuePropName="file"
        >
           <Upload {...props('addcomument')} multiple={true} showUploadList={true} >
              <Button icon={<UploadOutlined />}>Upload Document</Button>
            </Upload>
            {/* {formData?.files} */}
        </Form.Item>
          <Form.Item>
            <Button
              type="primary" htmlType="submit" 
              onClick={handleSubmit}
              style={{ display: 'block', margin: '0 auto' }}
            >
              Send Quote to Buyer
            </Button>
          </Form.Item>
        </Form>
      </Drawer>
      <style>
        {`
          .table-row-light {
            background-color: #e0f7fa;
          }
          .table-row-dark {
            background-color: #ffffff;
          }
        `}
      </style>
    </div>
  );
  
};

export default AcceptedRfqs;
